import React from 'react';
import IconCalendar from 'assets/svgs/iconCalendar.svg';
import IconPin from 'assets/svgs/iconPin.svg';
import IconBuilding from 'assets/svgs/buildingIconNew.svg';
import './EventDashboardDetails.scss';

const EventDashboardDetails = ({date, name, children}) => (
  <div className="event-dashboard-details-section">
    {date && <div> <IconCalendar/> {date}</div>}
    {name && <div> <IconPin/> {name}</div>}
    {children && <div><IconBuilding/>{children}</div>}
  </div>
);

export default EventDashboardDetails;


